import { TrustpilotRating } from "@/components/TrustpilotRating";
import { useTrustpilotRating } from "@/hooks/useTrustpilotRatings";

interface DynamicTrustpilotRatingProps {
  entityType: string;
  entitySlug: string;
  fallbackRating: number;
  fallbackReviewCount: number;
  size?: "sm" | "md" | "lg";
  showScore?: boolean;
  showLogo?: boolean;
  showReviewCount?: boolean;
  trustpilotUrl?: string;
}

/**
 * A wrapper around TrustpilotRating that fetches dynamic ratings from the database
 */
export function DynamicTrustpilotRating({
  entityType,
  entitySlug,
  fallbackRating,
  fallbackReviewCount,
  size = "md",
  showScore = true,
  showLogo = true,
  showReviewCount = true,
  trustpilotUrl,
}: DynamicTrustpilotRatingProps) {
  const { data: trustpilotData } = useTrustpilotRating(entityType, entitySlug);

  const rating = trustpilotData?.rating ?? fallbackRating;
  const reviewCount = trustpilotData?.reviewCount ?? fallbackReviewCount;
  const url = trustpilotData?.trustpilotUrl ?? trustpilotUrl;

  const content = (
    <div className="flex items-center justify-start gap-2">
      <TrustpilotRating rating={rating} size={size} showScore={showScore} showLogo={showLogo} />
      {showReviewCount && (
        <span className="text-xs text-muted-foreground">
          ({reviewCount.toLocaleString('sv-SE')} omdömen)
        </span>
      )}
    </div>
  );

  if (url) {
    return (
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="inline-block hover:opacity-80 transition-opacity"
      >
        {content}
      </a>
    );
  }

  return content;
}
